
import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel';

import OrdersTab from './orders-tab.vue';

export default {
  components: {
    DxTabPanel, DxItem, OrdersTab,
  },
  props: {
    masterDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
};
